import { getData, postData } from "@/utils/http";
import { getApplicationCode } from "@/utils/user";
export default {
	namespaced: true,
	state: {
		tableLoading: true,
		addLoading: false,
		activeItem: null,
		tableList: [],
		appId: ""
	},
	mutations: {
		CHANGE_TABLE_LOADING(state, tableLoading) {
			state.tableLoading = tableLoading;
		},
		CHANGE_ADD_LOADING(state, tableLoading) {
			state.addLoading = tableLoading;
		},
		CHANGE_TABLE_DATA(state, list) {
			state.tableList = list;
		},
		CHANGE_ACTIVE_ITEM(state, item) {
			state.activeItem = item;
		},
		CHANGE_SEARCH_COLL(state, changeData) {
			if (changeData["changeKey"] == "orgId" && typeof changeData["data"] != "object") {
				state[changeData["changeKey"]] = [changeData["data"]];
			} else {
				state[changeData["changeKey"]] = changeData["data"];
			}
		},
	},
	actions: {
		//获取菜单列表
		getList({ commit, state }) {
			return new Promise((resolve) => {
				getData("system" + "/menu/tree?application=" + state.appId).then((res) => {
					if (res.state == 1) {
						commit("CHANGE_TABLE_DATA", res.data);
						resolve({
							state: 1,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg
						});
					}
				})
			})
		},

		//获取父级菜单
		getParentList({ commit, state },appId) {
			return new Promise((resolve) => {
				getData("system" + "/menu/tree?application=" +appId).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data:res.data
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data:[]
						});
					}
				})
			})
		},


		//添加
		add({ commit }, addData) {
			return new Promise((resolve) => {
				postData(`${"system"}/menu/save`, addData).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg
						});
					}
				})
			})
		},


		//删除
		remove({ commit }, id) {
			return new Promise((resolve) => {
				getData(`${"system"}/menu/delete?id=${id}`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功"
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg
						});
					}
				})
			})
		},

		//修改loading
		changeListloading({ commit }, value) {
			commit("CHANGE_TABLE_LOADING", value);
		},
		changeAddLoading({ commit }, value) {
			commit("CHANGE_ADD_LOADING", value);
		},
		//写入当前操作菜单
		setActiveItem({ commit }, item) {
			commit("CHANGE_ACTIVE_ITEM", item)
		},
		//写入查询条件
		setSearchData({ commit }, changeData) {
			commit("CHANGE_SEARCH_COLL", changeData)
		},


	}
}
